var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"matter-header"},[_c('div',{staticClass:"hero-image"}),_vm._v(" "),_c('div',{staticClass:"content__heading"},[_c('div',{staticClass:"title"}),_vm._v(" "),_c('h2',{},[_vm._v("Thoughts & Things")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c83d5d0a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/matter/MatterHeader.vue
// module id = null
// module chunks = 